
    import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
    import BaseVue from '@/components/BaseVue'
    import { Pulldown } from '../models/Pulldown'
    import { Authority } from '../models/Authority'
    import { CostDetail } from '../models/CostDetail'
    import { LogData } from '../models/LogData'
    import { Const } from '../scripts/Const';
    import { MsgConst } from '../scripts/MsgConst';
    import { StringUtil } from '../scripts/StringUtil';
    import { CostDetailSearchCondition } from '../models/CostDetailSearchCondition'
    import ControlManager from '../scripts/ControlManager';
    import MoneyTextField from '@/components/MoneyTextField.vue';
    import appBar from '@/components/AppBar.vue'

    @Component({ components: { appBar, MoneyTextField} })
    export default class CostEntryDialog extends BaseVue {

        @Prop({ type: Boolean, required: true }) private showDialog!: boolean
        @Prop({ type: String }) private targetDate: string
        @Prop({ type: Number }) private detailNo: number
        @Prop({ type: String }) private empCd: string
        
        //#region 変数
        private editCondition: CostDetail = new CostDetail()
        private searchCondition: CostDetailSearchCondition = new CostDetailSearchCondition()
        private authority: Authority = new Authority()
        private logs: LogData[] = []

        private eventNm = ''
        //コントロールごとの活性制御
        private controlManager = new ControlManager();

        @Ref('scrollTarget') scrollTarget!: HTMLElement;
        @Ref('costEntry_editBtn') editBtn!: Vue;
        @Ref('costEntry_deleteBtn') deleteBtn!: Vue;

        //#region ファイルアップロード
        private uploadFileData: any = null;
        private uploadFile: any = null;
        private deleteFlg = false;
        //#endregion


        //#region 表示制御

        //#region フッターボタン
        private showSavebtn = true
        private showDeletebtn = true
        //#endregion

        private showDecisionRemarks = false

        //ログ
        private showLog = false

        //#endregion

        //#region メッセージ
        private showMessage = false
        private messageType = 'info'
        private message = ''
	    //#endregion

        //#region ガイダンス
        private showGuidance = false
        private guidanceType = 'info'
        private guidance = ''
	    //#endregion

        //#region 活性制御

        //フッターボタン
        private disableSavebtn: boolean = false;
        private disableDeletebtn: boolean = false;

        private disableCostAmount: boolean = false;
	    //#endregion

        //#region ダイアログ
        private dialog = false
        private title = ''
        private dialogMsg = ''
	    //#endregion

        //#region プルダウン
        private costKbnList: Pulldown[] = []
	    //#endregion

        //決済理由
        private disabledecision = false
        private disableRemarks = false

	    //#endregion

        //#region イベント

        //#region 初期表示
        private async created() {
            ////条件を設定する
            this.editCondition = new CostDetail()
            this.editCondition.targetDate = this.$route.params.workingDate
            this.editCondition.empCd = this.$route.params.empCd
        }


        @Watch('showDialog', { immediate: true, deep: true })
        onShowDialogChanged(showDialog: boolean) {

            this.messageClear();

            this.initialize();

            if (showDialog === true) {
                //条件を設定する
                this.editCondition = new CostDetail()
                this.editCondition.targetDate = this.$route.params.workingDate
                this.editCondition.empCd = this.$route.params.empCd

                this.searchCondition.targetDate = this.targetDate;
                this.searchCondition.empCd = this.empCd;
                this.searchCondition.detailNo = this.detailNo;

                //勤務情報の取得
                this.getCostDetail()
            }
        }
	    //#endregion

        //#region 費目プルダウン変更
        @Watch('editCondition.costKbn', { immediate: true, deep: true })
        private categoryChange(costKbn: string) {

            if (costKbn === Const.CostKbn.DAILY_ALLOWANCE) {
                //日当選択の場合、金額に登録済の日当金額を設定し非活性にする
                this.editCondition.costAmount = this.editCondition.dailyAllowanceAmount;
                this.disableCostAmount = true;
            } else {
                this.disableCostAmount = false;
            } 
        }
        //#endregion

        //#region 添付ファイルインプット　変更
        private async onChangeFile(selectedFile: any) {
            if (this.uploadFile == null) return;
            this.uploadFileData = new Object();
            this.uploadFileData.type = this.uploadFile.type;
            this.uploadFileData.fileName = this.uploadFile.name;

            this.readFileAsync(this.uploadFile)
                .then((result) => {
                    this.uploadFileData.data = result;
                })
        }
        //#endregion

        //#region 添付ファイルインプット　クリア
        private onClearFile() {
            this.uploadFile = null;
            this.uploadFileData = null;
        }
        //#endregion

        //#region 添付ファイル　リンク押下
        async downloadReceiptFile(fileName: string) {

            try {

                await this.$axios({
                    url: 'api/CostEntryDialog/DownloadReceiptFile',
                    method: 'GET',
                    params: {
                        fileName: fileName,
                        empCd: this.editCondition.empCd,
                        year: (this.targetDate).substring(0, 4),
                        month: (this.targetDate).substring(4, 6),
                        date: (this.targetDate).substring(6, 8),
                        detailNo: this.editCondition.detailNo.toString(),
                    },
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });

            } catch (error) {
                this.showMessage = true
                this.message = StringUtil.stringFormat(MsgConst.COMMON.ERROR_004, '出力')
                this.messageType = 'error'
            }
        }

    //#endregion

        //#region 登録ボタン押下
        private clickEdit() {

            this.messageClear();

            this.eventNm = 'edit'
            if (this.uploadFileData == null
                && this.editCondition.costKbn !== Const.CostKbn.DAILY_ALLOWANCE
                && ((!this.editCondition.receiptInfo && this.deleteFlg === false) || (this.editCondition.receiptInfo && this.deleteFlg === true))) {
                //領収書が添付されていない場合、確認ダイアログを表示
                this.openDialog('確認', MsgConst.COST_DETAIL.CONFIRM_002)
            } else {
                this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_001, '経費明細'))
            }
        }
        //#endregion

        //#region 削除ボタン押下
        private clickDelete() {

            this.messageClear();

            //確認ダイアログ
            this.eventNm = 'delete'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_017, '経費明細'))
        }
        //#endregion

        //#region 閉じるボタン押下
        closeCostEntryDialog() {
            this.$emit('result', false);
        }
        //#endregion

        //#endregion


        //#region プライベートメソッド

        //#region 経費明細情報取得
        private async getCostDetail() {
            try {

                const data = {
                    SearchCondition: this.searchCondition
                }
                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostEntryDialog/Get', data)
                this.restoreAllFooterBtn();
                //webLogicのレスポンスにメッセージがある場合は表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (response.data.messageData.errFlg) {

                        //画面上部へスクロール
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                        return
                    }
                }

                //権限
                this.authority = response.data.authority
                //勤務時間
                if (response?.data?.editCondition !== undefined && response?.data?.editCondition !== null) {
                    this.editCondition = response.data.editCondition;

                    //ログ
                    this.logs = response.data.logList || []
                    //表示制御
                    this.displayShowControl();
                    this.displayDisableContorol();
                    //ガイダンスを表示する
                    this.getGuidance(response.data.editCondition.detailStatus)
                }
                else {
                    this.initialize();
                }

                //プルダウン
                this.costKbnList = response.data.costKbnList

                //画面上部へスクロール
                window.scrollTo({ top: 0, behavior: 'smooth' })
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
	    //#endregion

        //#region 経費明細　登録
        private async edit() {
            try {

                let formData = new FormData()

                if (this.uploadFile == null) {

                } else {
                    formData.append(
                        "file",
                        new Blob([this.uploadFileData.data], { type: this.uploadFileData.type }),
                        this.uploadFileData.fileName
                    );
                }
                formData.append(
                    "data",
                    JSON.stringify(this.editCondition),
                )

                formData.append(
                    "fileDeleteFlg",
                    JSON.stringify(this.deleteFlg),
                )
                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostEntryDialog/Edit', formData)
                this.restoreAllFooterBtn();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        //画面を初期化し再度読み込み
                        this.initialize()
                        this.searchCondition.targetDate = this.targetDate;
                        this.searchCondition.empCd = this.empCd;
                        this.searchCondition.detailNo = response.data.editResult.detailNo;
                        this.getCostDetail()
                        //親画面の経費一覧を再取得
                        this.$emit('update');
                    }
                    return
                }
                //ガイダンスを表示する
                this.getGuidance(response.data.editCondition.requestStatus)

            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region 経費明細　削除
        private async delete() {
            try {

                const data = {
                    EditCondition: this.editCondition,
                }
                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostEntryDialog/delete', data)
                this.restoreAllFooterBtn();
                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        //画面を更新不可にする
                        this.disableSavebtn = true;
                        this.disableDeletebtn = true;
                        //親画面の経費一覧を再取得
                        this.$emit('update');
                        //ガイダンス非表示
                        this.showGuidance = false
                        this.guidance = ''
                    }
                    return
                }
                //ガイダンスを表示する
                this.getGuidance(response.data.editCondition.requestStatus)

            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region ガイダンスを表示する
        private getGuidance(detailStatus: string) {
            //何をすべきかガイダンスする
            this.showGuidance = false
            this.guidance = ''

            this.guidanceType = 'info'

            ////否認判定
            if (detailStatus == Const.CostDetailStatus.REMAND && this.showMessage == false) {
                this.guidanceType = 'error'
                this.guidance += MsgConst.COMMON.ERROR_001
                this.showGuidance = true
                return
            }

            //承認待ち判定
            if (detailStatus == Const.CostDetailStatus.AWAITING_APPROVAL) {
                this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_002, '経費明細')
                this.showGuidance = true
                return
            }

            //承認済み判定
            if (detailStatus == Const.CostDetailStatus.APPROVED) {
                this.guidance = MsgConst.COST_DETAIL.INFO_001
                this.showGuidance = true
                return
            }

            //締済み判定
            if (detailStatus == Const.CostDetailStatus.CLOSING) {
                this.guidance = MsgConst.COMMON.INFO_004
                this.showGuidance = true
                return
            }

        }
	    //#endregion

        //#region 画面項目初期化
        private initialize() {
            this.editCondition = new CostDetail();


            this.editCondition.empCd = this.empCd;
            this.editCondition.targetDate = this.targetDate;
            this.disableCostAmount = false;
            this.deleteFlg = false;
            this.uploadFile = null;
            this.uploadFileData = null;
        }
        //#endregion

        //#region 画面項目の表示制御
        private displayShowControl() {

            //処理前にすべて非表示状態にする
            this.showSavebtn            = false;
            this.showDeletebtn          = false;
            this.showDecisionRemarks    = false;

            //ログインユーザーまたは勤怠管理権限または管理職
            if (this.editCondition.empCd === this.authority.loginEmpCd || this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {

                if (this.editCondition.detailStatus === Const.CostDetailStatus.UNREGISTERED) {
                    this.showSavebtn    = true;
                }
                if (this.editCondition.detailStatus === Const.CostDetailStatus.MAKING) {
                    this.showSavebtn    = true;
                    this.showDeletebtn  = true;
                }
                if (this.editCondition.detailStatus === Const.CostDetailStatus.REMAND) {
                    this.showSavebtn    = true;
                    this.showDeletebtn  = true;
                }
                if (this.editCondition.detailStatus === Const.CostDetailStatus.AWAITING_APPROVAL) {
                    this.showSavebtn    = true;
                    this.showDeletebtn  = true;
                }

            }

            //決裁理由
            if (this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {
                if (this.editCondition.detailStatus === Const.CostDetailStatus.AWAITING_APPROVAL
                    || this.editCondition.detailStatus === Const.CostDetailStatus.REMAND
                    || this.editCondition.detailStatus === Const.CostDetailStatus.APPROVED) {
                    this.showDecisionRemarks = true;
                }
            } else {
                if (this.editCondition.detailStatus === Const.CostDetailStatus.AWAITING_APPROVAL
                    || this.editCondition.detailStatus === Const.CostDetailStatus.REMAND
                    || this.editCondition.detailStatus === Const.CostDetailStatus.APPROVED) {
                    if (this.editCondition.decisionRemarks) {
                        this.showDecisionRemarks = true;
                    }
                }
            }
        }
        //#endregion

        //#region　画面項目の活性制御
        private displayDisableContorol() {
            //処理前にすべて非活性状態にする
            this.disableSavebtn = true;
            this.disableDeletebtn = true;

            if (this.editCondition.monthlyStatus === Const.CostMonthlyStatus.UNREGISTERED) {
                this.disableSavebtn     = false;
                this.disableDeletebtn   = false;
            }
            if (this.editCondition.monthlyStatus === Const.CostMonthlyStatus.MAKING) {
                this.disableSavebtn     = false;
                this.disableDeletebtn   = false;
            }
            if (this.editCondition.monthlyStatus === Const.CostMonthlyStatus.REMAND) {
                this.disableSavebtn     = false;
                this.disableDeletebtn   = false;
            }

        }
        //#endregion

        //#region メッセージクリア
        private messageClear() {
            this.message = ''
            this.showMessage = false
        }
        //#endregion

        //#region dialog
        //はい・いいえダイアログ
        private openDialog(title: string, msg: string) {
            this.title = title
            this.dialogMsg = msg
            this.dialog = true
        }
        //#endregion

        //#region ダイアログイベント
        private dialogEvent(reply: string) {
            this.avoidMultipost(async () => {
                if (reply == 'yes') {
                    //はいが押された場合
                    switch (this.eventNm) {
                        case 'edit':
                            this.edit()
                            break
                        case 'delete':
                            this.delete()
                            break
                        default:
                            break
                    }
                } else {
                    //いいえが押された場合
                    switch (this.eventNm) {
                        default:
                            break
                    }
                }
                //ダイアログを閉じる
                this.dialog = false
                this.eventNm = ''
            })
        }
        //#endregion

        //#region　添付ファイルインプット　表示制御
        private get isShowFileInput(): boolean {
            if (!this.editCondition.receiptInfo) {
                return true;
            } else if (this.deleteFlg) {
                return true;
            }
            else {
                return false;
            }
        }
        //#endregion

        //#region　添付ファイルリンク　表示制御
        private get isShowFileLink(): boolean {
            if (this.editCondition.receiptInfo && this.deleteFlg === false) {
                return true;
            } else {
                return false;
            }
        }
        //#endregion

        //#region ファイルデータ読込
        private async readFileAsync(readFile: any) {

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                }

                reader.onerror = reject
                reader.readAsArrayBuffer(readFile)
            })
        }
        //#endregion

        //#region メッセージまでスクロールする
        private scrollToMessage() {
            if (this.scrollTarget) {
                this.scrollTarget.scrollIntoView({
                    behavior: 'smooth', // スムーズスクロール
                    block: 'center', // 要素を中央に配置
                    inline: 'nearest' // 横方向のスクロールを最小限に
                });
            }
        }
        //#endregion

        //#region すべてのフッターボタンを一時非活性状態にする
        private disableAllFooterBtn() {
            this.$nextTick(() => {
                this.controlManager.disableControl(this.editBtn);
                this.controlManager.disableControl(this.deleteBtn);
            });
        }
        //#endregion

        //#region すべてのフッターボタンを一時非活性解除する
        private restoreAllFooterBtn() {
            this.$nextTick(() => {
                this.controlManager.restoreControl(this.editBtn);
                this.controlManager.restoreControl(this.deleteBtn);
            });

            this.displayDisableContorol();
        }
        //#endregion

        //#endregion 


    }
